import { Component, Input } from '@builder.io/sdk';

const languages = [
  { label: 'Bash', value: 'bash' },
  { label: 'GraphQL', value: 'graphql' },
  { label: 'HTML', value: 'html' },
  { label: 'JavaScript', value: 'javascript' },
  { label: 'JSON', value: 'json' },
  { label: 'Python', value: 'python' },
  { label: 'SQL', value: 'sql' },
  { label: 'TXT', value: 'txt' },
  { label: 'TypeScript', value: 'typescript' },
  { label: 'XML', value: 'xml' },
] as const;

const codeBlockFields = [
  {
    name: 'language',
    type: 'string',
    enum: languages,
    defaultValue: 'javascript',
    required: true,
    helperText: 'Select the programming or markup language for syntax highlighting.',
  },
  {
    name: 'code',
    type: 'code',
    helperText:
      'Paste your code snippet here. Use the "Language" dropdown above (not the one inside this field) to enable proper syntax highlighting.',
  },
] as const satisfies DeepReadonly<Input[]>;

const codeBlockConfig = {
  name: 'codeBlock',
  inputs: codeBlockFields,
} as Component;

export type CodeBlockFields = GenerateBuilder<typeof codeBlockFields>;

export default codeBlockConfig;
